// extracted by css-extract-rspack-plugin
export default {"root":"zW81bJEoVucOqAWO","pinToggle":"A4hDLU_Unxwiphcv","pinToggleButton":"Zc7vD1YTFYQPmn4x"};